module.exports = __webpack_public_path__ + "img/event-salon1.1d782478.png";